/**
 * このゲームの識別子。**Phaser を引かない軽いモジュール**にしておく
 * （`registry.ts` と `platform/` から参照されるので、ここが重いと初期バンドルが太る）。
 *
 * 🔴 **この文字列は後から変更できない**。D1 の `game_key` / `src/games/<key>/` /
 *   `src/locales/<lang>/<key>.json` / `public/assets/<key>/` / localStorage の `<key>.*`
 *   が全部これと同じでなければならない（CLAUDE.md の規則1）。
 *
 * 🔴 **「数独」は株式会社ニコリの登録商標**なので使わない。一般名の「ナンバープレース」
 *   （英語では Number Place）を採る。`sudoku` も避ける＝商標の訳語として通っているため。
 */
export const GAME_KEY = 'nanpure';
